const product = {
  copy_distribution: () => {
    const descriptionContainer = document.querySelector('.s-product__description')
    const proprofiles = Array.from(document.querySelectorAll('[data-product-profile]'))

    proprofiles.map((profile) => {
      const thisprofile = profile
      const markup = window.productDetailsJSON.details.profile
      if (thisprofile && markup) {
        const [, text] = /<p>(.*?)<\/p>/g.exec(markup)
        if (text.length) {
          thisprofile.innerHTML = text
        }
      }

      return true
    })

    if (window.productDetailsJSON.details && descriptionContainer) {
      const sections = Object.entries(window.productDetailsJSON.details)

      sections.map((section) => {
        const copy = section[1]
        const title = section[0]

        if (title !== 'profile') {
          descriptionContainer.innerHTML += `<div>${copy}</div>`
        }
      })
    }
  },

  enable: () => {
    // subscription panel toggle
    product.sub_panel_toggle()

    // variant toggle
    product.variant_toggle()

    // cocktail toggle
    product.cocktail_toggle()

    if (!window.productDetailsJSON) {
      return
    }

    // move copy in to correct places
    product.copy_distribution()
  },

  sub_panel_toggle: () => {
    const toggles = Array.from(document.querySelectorAll('.s-product__sub-toggle-panel'))

    toggles.map((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault()

        document.body.classList.toggle('s-subscription-panel--active')

        document.body.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
      })

      return true
    })
  },

  cocktail_toggle: () => {
    const details = Array.from(document.querySelectorAll('.s-product__variant-detail label'))

    details.map((detail) => {
      const butt = detail.parentElement.querySelector('.c-btn')

      if (butt) {
        butt.addEventListener('click', (e) => {
          butt.previousElementSibling.click()
        })

        detail.addEventListener('click', (e) => {
          butt.click()
        })
      }
    })
  },

  variant_toggle: () => {
    const details = Array.from(document.querySelectorAll('.s-product__variant-detail'))
    const toggles = Array.from(document.querySelectorAll('.s-product__variant'))
    const images = Array.from(document.querySelectorAll('.s-product__image'))

    toggles.map((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault()

        if (e.target.dataset.variantTargetId) {
          const deta = document.querySelector(`[data-variant-id="${e.target.dataset.variantTargetId}"]`)
          const newImage = document.querySelector(`[data-variant-image-id="${e.target.dataset.variantTargetId}"]`)

          if (deta) {
            toggles.map((tog) => {
              tog.classList.remove('s-product__variant--active')

              return true
            })

            details.map((detail) => {
              detail.classList.remove('s-product__variant-detail--active')

              return true
            })

            images.map((image) => {
              image.classList.remove('s-product__image--active')

              return true
            })

            // update url
            window.history.replaceState(
              {},
              '',
              `${window.location.pathname}?variant=${e.target.dataset.variantTargetId}`,
            )

            // update image
            newImage.classList.add('s-product__image--active')

            // update link classes
            e.target.classList.add('s-product__variant--active')
            deta.classList.add('s-product__variant-detail--active')
          }
        }
      })

      return true
    })
  },
}

export default product
